














































































import {Component, Vue} from "vue-property-decorator";
import { ProjectVersion } from "@/models/project-version";
import { ProjectService } from "@/services/project-service";

@Component({
    name: 'ProjectVersions'
})
export default class ProjectVersions extends Vue {

    fields: object[] = [
        {key: 'id', label: 'ID'},
        {key: 'name', label: 'Name', tdClass: 'td-bold'},
        {key: 'description', label: 'Description'},
        {key: 'status', label: 'Status'},
        {key: 'estimated_hours', label: 'Estimated hours'},
        {key: 'spent_hours', label: 'Spent hours'},
        {key: 'done_ratio', label: 'Done ratio'},
        {key: 'updated_on', label: 'Updated on'},
    ];

    totalRows = 1;
    currentPage = 1;
    perPage = 5;
    pageOptions = [5, 10, 15];
    sortBy = 'updated_on';
    sortDesc = true;
    sortDirection = 'asc';
    filter = null;

    project_id!: string;
    project_versions: Array<ProjectVersion> = new Array<ProjectVersion>();

    project_service: ProjectService = new ProjectService();

    constructor() {
        super();
    }

    created() {
        this.project_id = this.$route.params.id;
        this.getProjectVersions();
    }

    activated() {
        this.project_id = this.$route.params.id;
        this.getProjectVersions();
    }

    getProjectVersions() {
        this.project_service.getProjectVersions(this.project_id)
        .then((response) => {
            this.project_versions = response.data;
            this.totalRows = response.meta.totalSize;
        })
        .catch((error) => {
            console.log("Error: ", error);
        });
    }

}
